import FilterItem from './FilterItem';
import styles from './filterItem.module.scss';

export { styles as filterItemStyles };
export default FilterItem;
